module.exports = __webpack_public_path__ + "img/vslbooster-logo-dark.b48c991d.svg";